import defaultMetaInfo, {genHeadOverrides,} from '@/assets/js/src/layout/meta'
import {getActivePinia,} from "pinia"
import {useMessagesLoaded,} from "@/assets/js/src/modules/lang/_composables/useMessagesLoaded"
import {useTranslation,} from "@/assets/js/src/util/composables/useTranslation"
import {computed,} from "vue"
import {useRoute,} from "vue-router"
import {useHead,} from "@unhead/vue"

export const useHeadInfo = () => {
    const {messagesLoaded,} = useMessagesLoaded([ 'common', ])
    const {t,} = useTranslation()
    const activePinia = getActivePinia()
    const currentRoute = useRoute()

    const title = computed(() => {
        return messagesLoaded.value
            ? t('async.common.home.title')
            : ''
    })

    let info = {
        title,
        ...defaultMetaInfo(activePinia),
    }

    info.meta = info.meta.map((metaTag) => {
        let metaTagId = metaTag.property ?? metaTag.name
        if ([ 'og:description', 'description', ].includes(metaTagId)) {
            metaTag.content = computed(()=>{
                return messagesLoaded.value
                    ? t('async.common.meta.description.default')
                    : ''
            })
        }

        if ([ 'og:title', ].includes(metaTagId)) {
            metaTag.content = title
        }

        return metaTag
    })

    if ([ 'Home', 'HomeML', ].includes(currentRoute.name)) {
        info.link.push({
            rel: 'amphtml',
            key: 'amphtml',
            href: computed(() => {
                return activePinia.state.value.baseUrl + '/amp'
            }),
        })
    }

    useHead(info)
}

export const useHeadInfoTitle = ({titleKey,descriptionKey,}) => {
    let keys = new Set()
    Object.values({titleKey,descriptionKey,}).forEach((key) => {
        key && keys.add(key.split('.')[1])
    })

    const {messagesLoaded,} = useMessagesLoaded(Array.from(keys))
    const {t,} = useTranslation()

    const title = computed(() => {
        return messagesLoaded.value
            ? t(titleKey)
            : ''
    })

    let description
    if(descriptionKey) {
        description = computed(() => {
            return messagesLoaded.value
                ? t(descriptionKey)
                : ''
        })
    }

    useHead(genHeadOverrides({title, description,}))

    return {
        title,
    }
}
